
import Uploader from '@/components/Uploader/index.vue';
import { reduceFileAccept } from '@/common/file';

export default {
  components: {
    Uploader: Uploader
  },

  props: {
    limit: {
      type: Number
    },

    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    onSuccess: {
      type: Function,
      default: function _default() {}
    },

    onChange: {
      type: Function,
      default: function _default() {}
    },

    onRemove: {
      type: Function,
      default: function _default() {}
    },

    multiple: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      maxSize: 50
    };
  },


  computed: {
    uploaderParams: function uploaderParams() {
      return {
        drag: true,
        withCredentials: true,
        data: { local: 1 },
        accept: reduceFileAccept(['mp4', 'mov', 'jpg', 'png', 'bmp', 'gif', 'png']),
        limit: this.limit,
        fileList: this.fileList,
        multiple: this.multiple
      };
    }
  },

  methods: {
    beforeUpload: function beforeUpload(file) {
      var isLtMaxSize = file.size / 1024 / 1024 < this.maxSize;

      if (!isLtMaxSize) {
        this.$message.error('上传文件大小不能超过 50MB!');
      }
      return isLtMaxSize;
    },
    onError: function onError() {
      this.$message.error('文件上传出错！');
    }
  }
};